export const ExitIcon = props => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_6033_20357"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="15"
      height="15"
    >
      <rect x="0.5" y="0.5" width="14" height="14" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6033_20357)">
      <path
        d="M12.2542 8.08333H5.75C5.58472 8.08333 5.44618 8.02743 5.33437 7.91563C5.22257 7.80382 5.16667 7.66528 5.16667 7.5C5.16667 7.33472 5.22257 7.19618 5.33437 7.08438C5.44618 6.97257 5.58472 6.91667 5.75 6.91667H12.2542L11.7583 6.42083C11.6417 6.30417 11.5858 6.16806 11.5906 6.0125C11.5955 5.85694 11.6514 5.72083 11.7583 5.60417C11.875 5.4875 12.0135 5.42674 12.174 5.42187C12.3344 5.41701 12.4729 5.47292 12.5896 5.58958L14.0917 7.09167C14.2083 7.20833 14.2667 7.34444 14.2667 7.5C14.2667 7.65556 14.2083 7.79167 14.0917 7.90833L12.5896 9.41042C12.4729 9.52708 12.3344 9.58299 12.174 9.57812C12.0135 9.57326 11.875 9.5125 11.7583 9.39583C11.6514 9.27917 11.5955 9.14306 11.5906 8.9875C11.5858 8.83194 11.6417 8.69583 11.7583 8.57917L12.2542 8.08333ZM9.25 5.16667V3.41667H3.41667V11.5833H9.25V9.83333C9.25 9.66806 9.3059 9.52951 9.41771 9.41771C9.52951 9.3059 9.66806 9.25 9.83333 9.25C9.99861 9.25 10.1372 9.3059 10.249 9.41771C10.3608 9.52951 10.4167 9.66806 10.4167 9.83333V11.5833C10.4167 11.9042 10.3024 12.1788 10.074 12.4073C9.84549 12.6358 9.57083 12.75 9.25 12.75H3.41667C3.09583 12.75 2.82118 12.6358 2.59271 12.4073C2.36424 12.1788 2.25 11.9042 2.25 11.5833V3.41667C2.25 3.09583 2.36424 2.82118 2.59271 2.59271C2.82118 2.36424 3.09583 2.25 3.41667 2.25H9.25C9.57083 2.25 9.84549 2.36424 10.074 2.59271C10.3024 2.82118 10.4167 3.09583 10.4167 3.41667V5.16667C10.4167 5.33194 10.3608 5.47049 10.249 5.58229C10.1372 5.6941 9.99861 5.75 9.83333 5.75C9.66806 5.75 9.52951 5.6941 9.41771 5.58229C9.3059 5.47049 9.25 5.33194 9.25 5.16667Z"
        fill="#5663F2"
        fillOpacity="0.5"
      />
    </g>
  </svg>
);
